import script from "./ProductCreate.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCreate.vue?vue&type=script&setup=true&lang=js"

import "./ProductCreate.vue?vue&type=style&index=0&id=943192aa&lang=scss"

const __exports__ = script;

export default __exports__